export class MemoryPlaybackEventStore {
    snapshot = null;
    async load() {
        if (!this.snapshot)
            return [];
        return {
            ...this.snapshot,
            events: this.snapshot.events.map((event) => ({ ...event })),
        };
    }
    async save(snapshot) {
        this.snapshot = {
            ...snapshot,
            events: snapshot.events.map((event) => ({ ...event })),
        };
    }
}
//# sourceMappingURL=memory-playback-event-store.js.map